const OnboardingModule = () => {
  return (
    <div>
      <h4>온보딩 모듈</h4>
    </div>
  );
};

export default OnboardingModule;
